export default {
    connectHeaders: {
        'protocol-version': '1.5',
    },
    stomp: {
        heartbeat: {
            outgoing: 10000,
            incoming: 10000,
        },
    },
};
